/**
 * S-6: spinner podwojny pierscien - tor w --border plus luk w --primary.
 *
 * Kilka gotowcow (pipeline.html, data-table.html) ma skrot jednoobwodowy; to nie jest
 * wzorzec S-6. Jedna rodzina spinnerow w calej aplikacji (MG-5).
 *
 * Przy prefers-reduced-motion animacja SPOWALNIA do 1400 ms, a nie znika - spinner
 * informuje, ze cos trwa, wiec zatrzymany klamalby.
 */
export function Spinner({ rozmiar = "m" }: { rozmiar?: "s" | "m" | "l" }): React.JSX.Element {
  return (
    <div className={`spinner spinner--${rozmiar}`} aria-hidden="true">
      <div className="spinner__track" />
      <div className="spinner__arc" />
    </div>
  );
}
